import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import { SocketProvider } from './hooks/useSocket';
import Login from './pages/Login';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Monitoramento from './pages/Monitoramento';
import Mensagens from './pages/Mensagens';
import Atendentes from './pages/Atendentes';
import Contatos from './pages/Contatos';
import Conversas from './pages/Conversas';
import Alertas from './pages/Alertas';
import Produtividade from './pages/Produtividade';
import GestorIA from './pages/GestorIA';
import Campanhas from './pages/Campanhas';
import Transcricoes from './pages/Transcricoes';
import Substituto from './pages/Substituto';
import Kanban from './pages/Kanban';
import FlowBuilder from './pages/FlowBuilder';

function PrivateRoute({ children }) {
  const { token } = useAuth();
  return token ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*" element={
            <PrivateRoute>
              <SocketProvider>
                <Layout>
                  <Routes>
                    <Route path="/"              element={<Dashboard />} />
                    <Route path="/monitoramento" element={<Monitoramento />} />
                    <Route path="/mensagens"     element={<Mensagens />} />
                    <Route path="/atendentes"    element={<Atendentes />} />
                    <Route path="/contatos"      element={<Contatos />} />
                    <Route path="/conversas"     element={<Conversas />} />
                    <Route path="/alertas"       element={<Alertas />} />
                    <Route path="/produtividade" element={<Produtividade />} />
                    <Route path="/gestor"        element={<GestorIA />} />
                    <Route path="/campanhas"     element={<Campanhas />} />
                    <Route path="/transcricoes"  element={<Transcricoes />} />
                    <Route path="/substituto"    element={<Substituto />} />
                    <Route path="/kanban"        element={<Kanban />} />
                    <Route path="/flowbuilder"   element={<FlowBuilder />} />
                  </Routes>
                </Layout>
              </SocketProvider>
            </PrivateRoute>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
